import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';


export interface JcTextProps extends JcCommonProps {
  readonly text: string;
}


export const JcText: React.FunctionComponent<JcTextProps> = (props: JcTextProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-text"]);

  return <p {...commonProps}>
    {props.text}
  </p>
}
